import { PDRModule } from '../PDRModule.js';
import { AccessibilityService } from './AccessibilityService.js';
export class DebugModule extends PDRModule {
  public accessibility = new AccessibilityService();
}